import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

export enum FiChecklistTimeIntervalType {
    OneTime = 0,
    RecurringDaily = 1,
    RecurringWeekly = 2,
    RecurringMonthly = 3,
    RecurringYearly = 4,
    OnDemand = 5,
    Audit = 6,
}

export const FiChecklistTimeIntervalLabels: INameIdObj[] = [
    {
        Id: FiChecklistTimeIntervalType.RecurringDaily,
        Name: 'checklist.repeat_frequency_daily',
    },
    {
        Id: FiChecklistTimeIntervalType.RecurringWeekly,
        Name: 'weekly',
    },
    {
        Id: FiChecklistTimeIntervalType.RecurringMonthly,
        Name: 'checklist.repeat_frequency_monthly',
    },
    {
        Id: FiChecklistTimeIntervalType.RecurringYearly,
        Name: 'checklist.repeat_frequency_yearly',
    },
    {
        Id: FiChecklistTimeIntervalType.OneTime,
        Name: 'checklist.one_time',
    },
    {
        Id: FiChecklistTimeIntervalType.OnDemand,
        Name: 'checklist.on_demand_checklist',
    },
    {
        Id: FiChecklistTimeIntervalType.Audit,
        Name: 'checklist.audit_control',
    },
];
